<template lang="pug">
    .snackbar
        transition-group(name="slide" appear mode="out-in")
            .message-container(v-for="(item, i) in messages" v-bind:class="'type-' + item.type" v-bind:key="('item-' + i)")
                p(v-html="item.message")
                md-button(v-bind:class="{'md-icon-button md-dense': true, 'md-accent': (item.type != 'error'), 'md-primary': (item.type == 'error') }" v-on:click="removeMessageImmediately(i)"): md-icon clear
</template>
<script>
    export default {
        name: 'snackbar',
        props: {},
        data() {
            return {
                messages: {}
            }
        },
        computed: {
            snackbar() {
                return this.$store.state.snackbar;
            }
        },
        watch: {
            'snackbar': {
                handler() {
                    this.getMessages();
                },
                deep: true
            },
        },
        methods: {
            getMessages() {
                if (!this.snackbar || !this.snackbar.message) return
                let message = Object.assign({}, this.snackbar);
                const exist = Object.values(this.messages).find(item => item.message === this.snackbar.message);
                if (exist) return;
                let i = (Object.keys(this.messages).length) + 1;
                this.$set(this.messages, i, message);
                this.removeMessage(i, message.duration);
            },
            removeMessage(i, duration) {
                setTimeout(() => {
                    if (this.messages[i]) this.$delete(this.messages, i);
                }, duration);
            },
            removeMessageImmediately(i) {
                if (this.messages[i]) this.$delete(this.messages, i)
            }
        },
        created() {}
    }
</script>
<style scoped lang="sass">
    .snackbar
        max-width: 400px
        height: auto
        max-height: 100vh
        position: absolute
        left: 10px
        bottom: 0
        z-index: 999
        transition: 0.25s ease-in-out
        a, .link
            color: #fff
            text-decoration: underline
        .message-container
            width: 100%
            background: #323232
            color: #fff
            display: flex
            align-items: center
            justify-content: space-between
            min-height: 40px
            margin: 0 0 10px 0
            padding: 5px 0 5px 10px
            border-radius: 3px
            font-size: 14px
            line-height: 16px
            word-break: break-word
        .message-container.type-default
            background: #323232
            color: #fff
        .message-container.type-error
            background: #f0002c
            color: #fff
        .message-container.type-success
            background: #00a863
            color: #fff

    .slide-enter
        transform: translateX(-10%)
        opacity: 0
    .slide-enter-active
        transition: ease-in-out .3s
    .slide-enter-to
        transform: translateX(0)
        opacity: 1
    .slide-leave
        transform: translateX(0%)
        opacity: 1
    .slide-leave-active
        transition: ease-in-out .3s
    .slide-leave-to
        transform: translateX(-10%)
        opacity: 0
</style>


// WEBPACK FOOTER //
// Snackbar.vue?56372b8e